module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "col-sm-4 col-md-offset-4 wallet-background p20 mb30"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Available Balance")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#f2f2f2"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.wallet_transactions.length != 0) ? _c('div', {
    attrs: {
      "id": "wallet-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-8 col-md-offset-2",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have any CNpay Transactions yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "12em"
    },
    attrs: {
      "id": "topup",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.wallet_payment_message != '') ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.wallet_payment_message))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("..reloading wallet")])]) : _c('div', [(_vm.wallet_payment_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_error_message))]) : _vm._e(), _vm._v(" "), (_vm.wallet_payment_calculated) ? _c('div', [_c('h5', [_vm._v("Amount: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt)))]), _vm._v(" "), _c('h5', [_vm._v("Processing Fee: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.processing_fee)))]), _vm._v(" "), _c('h6', [_vm._v("Total: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt + _vm.wallet_transaction.processing_fee)))]), _vm._v(" "), (_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._v("Proceed")])]) : _c('div', [_c('h4', [_vm._v("How much would you like to top-up with?")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "font-size": "13px",
      "border": "thin #22baae 1px",
      "text-align": "left",
      "border-radius": "2px",
      "background": "rgba(238, 229, 106, 0.473)",
      "line-height": "1.8"
    }
  }, [_vm._v("\r\n                            CNpay is a Closed Wallet. Top-up into CNpay CANNOT BE TRANSFERRED NOR WITHDRAWN AS CASH; funds in CNpay can only be spent within Cityneeds' platform for the purchase of Cityneeds' products and services.\r\n                        ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "11px"
    }
  }, [_vm._v("Top-up from ₦" + _vm._s(_vm.min_wallet_topup_amount) + " to ₦" + _vm._s(_vm.max_wallet_topup_amount))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_transaction.topay_amt),
      expression: "wallet_transaction.topay_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.wallet_transaction.topay_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_transaction.topay_amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prepareWalletPayment
    }
  }, [_vm._v("Enter")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_transaction_token != '') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_token))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Rewards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    staticStyle: {
      "margin-top": "-1em",
      "cursor": "pointer",
      "background": "#e7c619",
      "color": "#ffffff"
    },
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#topup"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Top-up CNpay Wallet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34fd1024"}!./src/components/CNwallet/template.html
// module id = 280
// module chunks = 0